import { render, staticRenderFns } from "./QuizButton.vue?vue&type=template&id=97c94b64"
import script from "./QuizButton.vue?vue&type=script&lang=js"
export * from "./QuizButton.vue?vue&type=script&lang=js"
import style0 from "./QuizButton.vue?vue&type=style&index=0&id=97c94b64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports